import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import './BackupSuccess.css';

const BackupSuccess = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleProceed = () => {
    sessionStorage.setItem('walletJustConnected', 'true');
    navigate('/dashboard');
  };

  return (
    <div className="backup-success-page">
      <div className="backup-success-card">
        <CheckCircle2 size={62} className="success-icon" />
        <h1>Backup Successful</h1>
        <p className="backup-id">UID: {user?.walletId || 'Verified'}</p>
        <p className="backup-note">
          Congratulations, your wallet backup has been completed successfully.
          Your secure connection is now active and your portfolio data is being
          synced. Click proceed to continue to your dashboard.
        </p>
        <button className="proceed-btn" onClick={handleProceed}>
          Proceed to Dashboard
        </button>
      </div>
    </div>
  );
};

export default BackupSuccess;
